/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * 包含待解密文本 'text'、密钥 'key' 和随机数 'nonce' 的JSON对象
 */
export type PostTextAesDecryptRequest = {
  key: string;
  text: string;
  nonce: string;
};

export const PostTextAesDecryptRequest$zodSchema: z.ZodType<
  PostTextAesDecryptRequest
> = z.object({
  key: z.string(),
  nonce: z.string(),
  text: z.string(),
}).describe("包含待解密文本 'text'、密钥 'key' 和随机数 'nonce' 的JSON对象");

export type PostTextAesDecryptInternalServerErrorDetails = {};

export const PostTextAesDecryptInternalServerErrorDetails$zodSchema: z.ZodType<
  PostTextAesDecryptInternalServerErrorDetails
> = z.object({});

/**
 * 解密失败
 */
export type PostTextAesDecryptInternalServerErrorResponseBody = {
  code?: string | undefined;
  details?: PostTextAesDecryptInternalServerErrorDetails | undefined;
  message?: string | undefined;
};

export const PostTextAesDecryptInternalServerErrorResponseBody$zodSchema:
  z.ZodType<PostTextAesDecryptInternalServerErrorResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() =>
      PostTextAesDecryptInternalServerErrorDetails$zodSchema
    ).optional(),
    message: z.string().optional(),
  }).describe("解密失败");

export type PostTextAesDecryptBadRequestDetails = {};

export const PostTextAesDecryptBadRequestDetails$zodSchema: z.ZodType<
  PostTextAesDecryptBadRequestDetails
> = z.object({});

/**
 * 无效的请求参数
 */
export type PostTextAesDecryptBadRequestResponseBody = {
  code?: string | undefined;
  details?: PostTextAesDecryptBadRequestDetails | undefined;
  message?: string | undefined;
};

export const PostTextAesDecryptBadRequestResponseBody$zodSchema: z.ZodType<
  PostTextAesDecryptBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => PostTextAesDecryptBadRequestDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("无效的请求参数");

/**
 * 成功响应
 */
export type PostTextAesDecryptResponseBody = { plaintext?: string | undefined };

export const PostTextAesDecryptResponseBody$zodSchema: z.ZodType<
  PostTextAesDecryptResponseBody
> = z.object({
  plaintext: z.string().optional(),
}).describe("成功响应");

export type PostTextAesDecryptResponse =
  | PostTextAesDecryptResponseBody
  | PostTextAesDecryptBadRequestResponseBody
  | PostTextAesDecryptInternalServerErrorResponseBody;

export const PostTextAesDecryptResponse$zodSchema: z.ZodType<
  PostTextAesDecryptResponse
> = z.union([
  z.lazy(() => PostTextAesDecryptResponseBody$zodSchema),
  z.lazy(() => PostTextAesDecryptBadRequestResponseBody$zodSchema),
  z.lazy(() => PostTextAesDecryptInternalServerErrorResponseBody$zodSchema),
]);
